<template>
  <div>
    <div class="h-scroll h100-80">
      <div class="h-toolbarBg">
        <ejs-toolbar ref="toolbar">
          <e-items>
            <e-item prefixIcon='icon hero-icon hero-icon-advanced-search' :tooltipText='$t("Pm.queryInfo")' :click="noRealTaskDataQuery" operate='search'></e-item>
            <e-item prefixIcon='icon hero-icon hero-icon-quick-export' :tooltipText='$t("Pm.quickExport")' :click="noRealTaskDataExport" operate='export'></e-item>
          </e-items>
        </ejs-toolbar>
      </div>
    </div>
    <div class="h-pm-dataQuery-tree">
      <ejs-treeview ref='PmNoRealDataQueryLeftTree' :fields='fieldsOfResourceTreeForDataQuery' :nodeSelected='nodeSelectedOfResourceTreeForDataQuery'></ejs-treeview>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PmNoRealDataQueryLeftTree',
  components: {
  },
  data() {
    return {
      fieldsOfResourceTreeForDataQuery: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text',
      }
    }
  },
  methods: {
    initResourseTreeForDataQuery(){
      this.$axios.post(`/lte/ems/pm/noReal/query/buildNoRealTaskResourceTreeForDataQuery.html`).then((response) => {
        this.fieldsOfResourceTreeForDataQuery = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state',
          iconCss: 'iconCls'
        };
      });
    },
    // 数据查询
    noRealTaskDataQuery() {
      this.$parent.$parent.$refs.PmNoRealDataQueryRightList.pmNoRealTaskDataQuery();
    },

    // 导出
    noRealTaskDataExport() {
      this.$parent.$parent.$refs.PmNoRealDataQueryRightList.pmNoRealTaskDataExport();
    },

    nodeSelectedOfResourceTreeForDataQuery(node){
      if (node.nodeData.id != 'root' && node.nodeData.parentID != 'root') {
        this.$refs.toolbar.enableItems([0, 1], true);
      } else {
        this.$refs.toolbar.enableItems([0, 1], false);
      }
      this.$emit('transferNodeInfoOfResourceTreeSelected', node);
    }
  },
  mounted() {
    this.initResourseTreeForDataQuery();
  }
};
</script>

<style>

</style>
